import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input } from 'antd';
import Button from '../../components/uielements/button';
import authAction from '../../redux/auth/actions';
import IntlMessages from '../../components/utility/intlMessages';
import notification from '../../components/notification';
import SignInStyleWrapper from './signin.style';
import Config from "../../settings/urbanice-api";
import { siteConfig } from "../../settings";
import axios from "axios";
import { user_admin, user_sales, user_sales_co, user_finance, user_cs, user_marketer} from "../../settings/user";

const AUTH_BASIC = process.env.REACT_APP_AUTH_BASIC;
const GRANT_ACCESS_TOKEN_V2 = Config.GRANT_ACCESS_TOKEN_V2; //<== Deprecate
const GRANT_ACCOUNT_ACCESS_TOKEN = Config.GRANT_ACCOUNT_ACCESS_TOKEN;
const GET_USER_INFO = Config.GET_USER_INFO;
const { login } = authAction;
const DEBUG = siteConfig.DEBUG
class SignIn extends Component {
  state = {
    redirectToReferrer: false,
    //Auth
    email:'',
    password: '', 
    confirmLoading: false,
    //UserInfoV2
    userInfoV2: '',
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isLoggedIn !== nextProps.isLoggedIn &&
      nextProps.isLoggedIn === true
    ) {
      this.setState({ redirectToReferrer: true });
    }
  }


  /*******************/
  /***** AUTH V2 *****/
  /*******************/
  /***** HANDLE ENTER BUTTON FUNCTION *****/
  handleKeyDown = (e) =>  {
    if (e.key === 'Enter') {
      DEBUG && console.log('HIT ENTER!');
     this.handleLoginEMAIL();
    }
  }

  /***** HANDLE LOGIN EMAIL FUNCTION *****/
  handleLoginEMAIL = () => {
    DEBUG && console.log('EMAIL LOGIN CLICKED!')
    const { email, password  } = this.state;

    if (!(email && password)) {
      notification('error', 'กรุณากรอกอีเมลและรหัสผ่าน');
      return null;
    }

    this.handleUrbaniceAuth(email, 'EMAIL', password);
  }


  /***** HANDLE URBANICE AUTH FUNCTION *****/
  handleUrbaniceAuth = (userIdentity, idenityType,accessToken) => {
    const { accessTokenData, email, password  } = this.state;
    const { login } = this.props;

    DEBUG && console.log(`handleUrbaniceAuth`);
    DEBUG && console.log(`handleUrbaniceAuth_accessTokenData: ${accessTokenData}`)
    DEBUG && console.log(`handleUrbaniceAuth_userIdentity: ${userIdentity}`);
    DEBUG && console.log(`handleUrbaniceAuth_idenityType: ${idenityType}`);
    DEBUG && console.log(`handleUrbaniceAuth_accessToken: ${accessToken}`);

    this.setState({
      confirmLoading: true,
    });

    if (!accessTokenData){
      //GRANT ACCESS TOKEN V2
      this.grantAccessToken_v2(userIdentity, idenityType, accessToken)
        .then((res) => {
          accessToken = res.access_token;
          localStorage.setItem('access_token', accessToken);

          //GET USER INFO V2
          this.getUserInfoV2(accessToken)
          .then((res) => {
            DEBUG && console.log(`RESPONSE : ${JSON.stringify(res)}`);
            DEBUG && console.log(`userID : ${res.userID}`);
            DEBUG && console.log(`firstname : ${res.profile.firstname}`);

              this.setState({
                confirmLoading: false,
              })

              const userID = res.userID;
              const userFirstname = res.profile.firstname;
              const userLastname = res.profile.lastname;
              const userImageUrl = res.profile.imageUrl;

              if(user_admin.includes(userID) || user_sales.includes(userID) || user_sales_co.includes(userID) || user_finance.includes(userID) || user_cs.includes(userID) || user_marketer.includes(userID)){
                localStorage.setItem('userID', userID);
                localStorage.setItem('userFirstname', userFirstname)
                localStorage.setItem('userLastname', userLastname)
                localStorage.setItem('userImageUrl', userImageUrl);

                login();
                this.props.history.push("/dashboard");

                DEBUG && console.log('Login Success')

              } else {
                notification('error', 'คุณไม่มีสิทธิในการเข้าใช้งานระบบนี้');
                DEBUG && console.log('Login Fail')
                this.setState({
                  confirmLoading: false,
                  accessTokenData: null,
                })
                return
              }   
          })
          .catch(error => {
            DEBUG && console.log('Error : ' + error);
            notification('error', error);
            this.setState({
              confirmLoading: false,
              accessTokenData: null,
            })
          })

        })
      .catch(err => {
        //notification('error', `ACCESS ERROR: ${err}`);
        DEBUG && console.log(`ACCESS ERROR : ${err}`);
        this.setState({
          confirmLoading: false,
          accessTokenData: null,
        });
        localStorage.removeItem('access_token');
      })

    }
  };


  /***** GRANT ACCESS TOKEN V2 FUNCTION *****/
  //async grantAccessToken_v2(email,password){
    async grantAccessToken_v2(userIdentity, idenityType, accessToken) {

      let DATA, GRANT_ACCESS_TOKEN_API = '';
  
      if (idenityType === 'GOOGLE_USER_ID') {
        DATA = {
          'identityType': idenityType,
          'userIdentity': userIdentity,
          'userCredential': accessToken,
          'entityType': 'PMC'
        };
        GRANT_ACCESS_TOKEN_API = GRANT_ACCOUNT_ACCESS_TOKEN;
      } else {
        DATA = {
          'grant_type': 'password',
          username: userIdentity,
          password: idenityType === 'EMAIL' ? accessToken : (idenityType === 'FACEBOOK_USER_ID' ? 'fb/' + accessToken : 'ap/' + accessToken)
        };
        GRANT_ACCESS_TOKEN_API = GRANT_ACCESS_TOKEN_V2;
      }
  
      DEBUG && console.log(`grantAccessToken_DATA: ${JSON.stringify(DATA)}`);
      DEBUG && console.log(`grantAccessToken_DATA: ${GRANT_ACCESS_TOKEN_API}`);
  
      
      // let dataInput = {
      //   'grant_type': 'password',
      //   username: userIdentity,
      //   password: idenityType === 'EMAIL' ? accessToken : (idenityType === 'FACEBOOK_USER_ID' ? 'fb/' + accessToken : 'ap/' + accessToken)
      // };
  
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          "Authorization": 'Basic ' + AUTH_BASIC,
        }
      };
      try {
        const res = await axios.post(GRANT_ACCESS_TOKEN_API, DATA, axiosConfig);
        const { data } = await res;
  
        if (data.errorMessage) {
          data.errorMessage === 'ERR_INVALID_USER_PASS' ? (
            notification('error', `โปรดตรวจสอบอีเมล และรหัสผ่านอีกครั้ง`)
          ) : (
              data.errorMessage === 'ERR_USER_NOT_EXIST' ? (
                notification('error', `ไม่มีบัญชีผู้ใช้นี้อยู่ในระบบ`)
              ) : (
                  notification('error', `Oops, something went wrong`)
                )
            )
          return await null;
        }
  
        this.setState({ accessTokenData: data }, () => {
          DEBUG && console.log(`accessTokenData: ${JSON.stringify(data)}`);
        });
        return await data;
      } catch (err) {
        notification('error', `ACCESS ERROR: ${err}`);
        DEBUG && console.log(`ACCESS ERROR : ${err}`);
        this.setState({
          confirmLoading: false,
          selectCommunityLoading: false,
        });
      }
    }
  

  /***** GET USER INFO FUNCTION - V2 *****/
  async getUserInfoV2(token){
    let axiosConfig = {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    };

    try{
      const res = await axios.get(GET_USER_INFO, axiosConfig);
      const { data } = await res;
      
      this.setState({userInfoV2: data},()=>{
        DEBUG && console.log(`userInfoV2: ${JSON.stringify(data)}`);
      });
      return await data;
    }catch(e){
      DEBUG && console.log(`Error: ${e}`);
    }     
  }

  
  /***** RENDER FUNCTION *****/
  render() {
    const from = { pathname: '/dashboard' };
    const { redirectToReferrer,confirmLoading } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }
    return (
      <SignInStyleWrapper className="isoSignInPage">
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <div className="isoLogoWrapper">
              <Link to="/dashboard">
                <IntlMessages id="page.signInTitle" />
              </Link>
            </div>

            <div className="isoSignInForm">
            <div className="isoInputWrapper">
                <Input 
                  autoFocus
                  ref={email => (this.email = email)}
                  size="large" 
                  placeholder="Email"
                  value={this.state.email}
                  onChange={event => {
                    this.setState({ email: event.target.value });
                  }}
                  />
              </div>

              <div className="isoInputWrapper">
                <Input.Password 
                  size="large" 
                  type="password" 
                  placeholder="Password"
                  value={this.state.password}
                  onChange={event => {
                    this.setState({password: event.target.value});
                  }}
                  onKeyDown={this.handleKeyDown}
                   />
              </div>

              <div className="isoInputWrapper isoCenterComponent">
                {/* <Button type="primary" onClick={this.handleUrbaniceAuth}> */}
                <Button type="primary" onClick={this.handleLoginEMAIL} loading={confirmLoading}>
                  <IntlMessages id="page.signInButton" />
                </Button>
              </div>

              <p className="isoHelperText">
                <IntlMessages id="page.signInPreview" />
              </p>

              <div className="isoCenterComponent isoHelperWrapper">
                <span className="isoForgotPass">
                  {siteConfig.footerText} {siteConfig.version}
                </span>
              </div>
            </div>
          </div>
        </div>
      </SignInStyleWrapper>
    );
  }
}

export default connect(
  state => ({
    isLoggedIn: state.Auth.idToken !== null ? true : false
  }),
  { login }
)(SignIn);
